import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/modify-legal';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';

class ModifyLegal extends React.Component {

  render() {
    const {
      t,
      isCustomer,
      customers,
      parentUuid,
      name,
      regulatoryLicense,
      onParentUuid,
      onName,
      onRegulatoryLicense,
      disabled
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value,
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.titleContainer}>
          <h6 className={classes.title}>{t('modifyLegal.title')}</h6>
        </div>
        <Row>
          {
            isCustomer ? null : (
              <Col md={4}>
                <FormGroup>
                  <Label for="modify_parentUuid">{t('modifyLegal.parentUuidLabel')}<span className={classes.requiredIndicator}>*</span></Label>
                  <Input
                    type="select"
                    name="modify_parentUuid"
                    id="modify_parentUuid"
                    disabled={disabled}
                    {...getFieldProps(parentUuid, onParentUuid)}
                  >
                    <option value="" disabled>{t('modifyLegal.parentUuidPlaceholder')}</option>
                    {
                      customers
                        .map(
                          ({ uuid, name }, index) => <option value={uuid} key={index}>{name}</option>
                        )
                    }
                  </Input>
                </FormGroup>
              </Col>
            )
          }
          <Col md={4}>
            <FormGroup>
              <Label for="modify_name">{t('modifyLegal.nameLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_name"
                id="modify_name"
                placeholder={t('modifyLegal.namePlaceholder')}
                disabled={disabled}
                {...getFieldProps(name, onName)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_regulatoryLicense">{t('modifyLegal.regulatoryLicenseLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_regulatoryLicense"
                id="modify_regulatoryLicense"
                placeholder={t('modifyLegal.regulatoryLicensePlaceholder')}
                disabled={disabled}
                {...getFieldProps(regulatoryLicense, onRegulatoryLicense)}
              />
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

}

ModifyLegal.propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ),
  isCustomer: PropTypes.bool,
  parentUuid: PropTypes.string,
  name: PropTypes.string.isRequired,
  regulatoryLicense: PropTypes.string.isRequired,
  onParentUuid: PropTypes.func,
  onName: PropTypes.func.isRequired,
  onRegulatoryLicense: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default translate(['customer'])(ModifyLegal);


// WEBPACK FOOTER //
// ./src/views/customer/modify-legal.js